import React, { createContext, useState, useEffect } from 'react';
import axios from 'axios';

export const storage = localStorage;

export const AppAuthContext = createContext("");

export const AppAuthProvider = (props) => {
    const [cid, setCid] = useState();
    const [customerInfo, setCustomerInfo] = useState();
    const [token, setToken] = useState('',);
    const [isAuth, setAuth] = useState(false);

    useEffect(() => {
        const c = () => {
            let path = window.location.pathname;
            path = path.replace(/\//g, '');
            if (path) {
                setCid(path);
            }
        }
        c();
    }, []);

    useEffect(() => {
        const effect = () => {
            if (cid) {
                getCustomerInfo(cid);
            }
        }
        effect();
    }, [cid]);

    // useEffect(() => {
    //     const effect = () => {
    //         if (customerInfo) {
    //             console.log(customerInfo);
    //         }
    //     }
    //     effect();
    // }, [customerInfo]);

    const getCustomerInfo = async (cid) => {
        return await axios.post(`/auth/cid?cid=${cid}`)
            .then(result => {
                if (result.data && result.data.title) {
                    setCustomerInfo(result.data);
                }
            })
            .catch((ex) => {
                setCustomerInfo(false);
            });
    }

    useEffect(() => {
        const uef = () => {
            if (token) {
                axios.defaults.headers = { 'Authorization': 'Bearer ' + token };
                storage.setItem("token", token);
            } else {
                axios.defaults.headers = null;
                // storage.removeItem("token");
            }
        }

        return uef();

    }, [token]);

    const initAuth = async () => {
        let t = storage.getItem("token");
        if (t) {
            if ((await CheckAuthenticated(t))) {
                setToken(t);
                setAuth(true);
            } else {
                setToken("");
                setAuth(false);
            }
        }
    }

    const getToken = () => {
        if (token) {
            return token;
        } else {

        }
        return token;
    }

    const SignIn = async (cid, username, password, rememberMe) => {
        const userData = {
            cid,
            username,
            password,
            agent: "transys.kavosh.app",
            rememberMe
        }
        // console.log(userData);
        return await axios.post('/auth/signin', userData)
            .then(result => {
                if (result.data && result.data.token) {
                    // console.log(result.data);
                    setToken(result.data.token);
                    setAuth(true);
                    return true;
                }
            })
            .catch((ex) => {
                if (ex.response && ex.response.status === 401) { setAuth(false) };
                return false;
            });
    }

    const SignOut = async () => {
        await axios.post('/auth/signout');
        axios.defaults.headers = null;
        storage.removeItem("token");
        setAuth(false);
        return false;
    }

    const UserInfo = async () => {
        return await axios.get("/api/userinfo")
            .then(result => {
                return result.data;
            })
            .catch((ex) => {
                if (ex.response && ex.response.status === 401) { setAuth(false) };
                return false;
            });
    }

    const ServerStatus = async () => {
        return await axios.get("/api/status")
            .then(result => {
                return result.data;
            })
            .catch((ex) => {
                if (ex.response && ex.response.status === 401) { setAuth(false) };
                return false;
            });
    }

    const CheckAuthenticated = async (token = getToken()) => {
        return await axios.get("/auth/isauthenticated", { headers: { "Authorization": "Bearer " + token } })
            .then(result => {
                return result.data;
            })
            .catch((ex) => {
                if (ex.response && ex.response.status === 401) { setAuth(false) };
                return false;
            });
    }

    return (
        <AppAuthContext.Provider value={{ cid, setCid, customerInfo, initAuth, isAuth, setAuth, getToken, SignIn, SignOut, UserInfo, ServerStatus, CheckAuthenticated }}>
            {props.children}
        </AppAuthContext.Provider>
    );
}